import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { PublicLayout, SectionHeading } from "../components/PublicLayout";

export default function PricingPage() {
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data)).catch(() => {}); }, []);

  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="pricing-page">
        <SectionHeading eyebrow="Pricing" title="One transparent fee. A small monthly membership."
          sub="Pay once to publish your book. Your plan includes 30 days of platform access — then a small monthly membership keeps your dashboard, sales tracking and payouts running." />
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {plans.map((p, i) => (
            <div key={p.id} data-testid={`pricing-card-${p.id}`}
              className={`relative border rounded-2xl p-8 bg-white transition-all hover:shadow-lg hover:-translate-y-0.5 ${i === 1 ? "border-neutral-900 shadow-md" : "border-neutral-200"}`}>
              {i === 1 && <span className="absolute -top-3 left-8 bg-neutral-900 text-white text-xs font-semibold px-3 py-1 rounded-full">Most popular</span>}
              <h3 className="font-semibold text-neutral-900 font-heading text-lg">{p.name}</h3>
              {p.custom ? (
                <>
                  <p className="text-4xl font-bold text-neutral-900 mt-3 font-heading">${p.monthly_price}<span className="text-base font-medium text-neutral-400">/mo</span></p>
                  <p className="text-xs text-neutral-500 mt-1">starting rate — final rate agreed with your publisher</p>
                </>
              ) : (
                <>
                  <p className="text-4xl font-bold text-neutral-900 mt-3 font-heading">${p.price}</p>
                  <p className="text-xs text-neutral-500 mt-1">one-time + ${p.monthly_price}/mo membership after the first 30 days</p>
                </>
              )}
              <p className="text-sm text-neutral-500 mt-3">{p.description}</p>
              <ul className="mt-5 space-y-2.5">
                {(p.features || []).map((f) => (
                  <li key={f} className="text-sm text-neutral-700 flex gap-2"><span className="text-emerald-600 font-bold">✓</span>{f}</li>
                ))}
              </ul>
              <Link to={p.custom ? "/contact" : "/register"} data-testid={`pricing-cta-${p.id}`}
                className={`mt-8 block text-center py-2.5 rounded-full text-sm font-medium transition-colors ${i === 1 ? "bg-neutral-900 text-white hover:bg-neutral-700" : "border border-neutral-300 text-neutral-800 hover:bg-neutral-50"}`}>
                {p.custom ? "Talk to us" : `Start with ${p.name}`}
              </Link>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
